export const ssKeys = {
	// Note: At least one image was successfully generated in previous generator's go
	IMG_GEN_PREV_SOME_SUCCESS: 'img-gen-prev-some-success',
	IMG_GEN_SUCCESS_GOES: 'img-gen-success-goes',
	IMG_GEN_REVIEW_ASKED: 'img-gen-review-asked',
	VIDEO_GEN_PREV_SOME_SUCCESS: 'video-gen-prev-some-success',
	VIDEO_GEN_SUCCESS_GOES: 'video-gen-success-goes',
	VIDEO_GEN_REVIEW_ASKED: 'video-gen-review-asked',
	CHAT_EXP_REVIEW_ASKED: 'chat-exp-review-asked',
	MARKERS: 'markers',
	G_TOOL_GENERATE_IN_PROGRESS: 'g-tool-generate-in-progress',
	ANNALS_SITE_VISIT_SENT: 'annals.site-visit-sent',
	GRID_FILTERS: 'grid.filters',
	GRID_FILTERS_MANUAL_UPDATE: 'grid.filters.manual.update',
	CONFIRM_EMAIL: 'confirm-email',
	PAYMENT_DOOMSDAY_COUNTER_TO_DATE: 'payment.doomsday-counter-to-date',
	// promocodes
	PROMOCODE: 'payment.default-promocode',
	NSFW_MODAL_SHOWN_FOR_DEMO: 'nsfw-modal-shown-for-demo',
	LOGGED_OUT_MANUAL: 'logged-out-manual',
	ANNALS_K_ID: 'annals.k-id',
	ANNALS_FBCLID: 'annals.fbclid',
	URL_BEFORE_SSO: 'url-before-sso',
	MEDIA_SHARE_CLICKED: 'media-share-clicked',
	GENERATOR_SCROLL_TO: 'generator-scroll-to',
};

export const lsKeys = {
	CONFIRMATION_TOASTER_SHOWED: 'confirmation-toaster-showed',
	HIDE_EMAIL_CONFIRM_MODAL: 'hide_email_confirm_modal',
	EMAIL_CONFIRM_BANNER_POSTPONED_AT: 'emailConfirm.bannerPostponedAt',
	EMAIL_CONFIRM_MODAL_SHOWN: 'emailConfirm.modalShown',
	EMAIL_CONFIRM_LAST_SENT: 'emailConfirm.lastSent',
	G_TOOL_FREE_GEN_SHOWN: 'gtool.freeGenShown',
	NEWS_MODAL_SHOWED: 'news.modal-showed',
	MODERATION_REVIEW_NOTIFICATION_SHOWN: 'moderation-review-notification-shown',
	MODERATION_BLOCKED_NOTIFICATION_SHOWN:
		'moderation-blocked-notification-shown',
	NSFW_MODAL_SHOWN_FOR_REGISTERED: 'nsfw.modal.shown.for.registered',
	G_TOOL_VIDEO_GEN_PAY_MODAL_HIDDEN: 'g-tool-video-gen-pay-modal-hidden',
	CHAT_VIDEO_GEN_PAY_MODAL_HIDDEN: 'chat-video-gen-pay-modal-hidden',
	PAYWALL_CLOSED_COUNT: 'paywall.closed.count',
};
